module.exports = __webpack_public_path__ + "img/qrcode.5c921038.jpg";